import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Service } from '@app-models/site';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SiteService } from '@app-services/site.service';
import { errorMessages } from '../../../../message/error';
import { checkInvalid } from '../../../validation';
import { LoadingScreenService } from '@app-services/loading-screen.service';

@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.scss']
})
export class AddServiceComponent implements OnInit {

  latlongPattern = new RegExp(
    /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/);
  e = errorMessages.TH;
  fg: FormGroup;
  newService: Service;
  latlong: string;
  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    public dialogServiceRef: MatDialogRef<AddServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public siteId: string,
    private fb: FormBuilder,
    private ss: SiteService,
    private ls: LoadingScreenService) { }

  ngOnInit() {
    this.newService = this.ss.newService();
    this.fg = this.fb.group({
      name: [this.newService.name, [Validators.required]],
      displayId: [this.newService.displayId, [Validators.required]],
      latlong: ['', [
        Validators.required,
        Validators.pattern(this.latlongPattern)]],
      numStatuses: [this.newService.queueStatuses.length]
    });
  }

  onSubmit(): void {
    this.fg.markAsDirty();
    if (!checkInvalid([this.fg], this.formElementRef, true)) {
      this.ls.startLoading();
      Object.assign(this.newService, this.fg.value);
      if (this.fg.get('numStatuses').value === 7) {
        this.newService.queueStatuses = this.ss.getDefaultStatusList(true);
      }
      const latlong = this.fg.value.latlong.split(',');
      this.newService.latitude = parseFloat(latlong[0]);
      this.newService.longitude = parseFloat(latlong[1]);
      delete this.newService.numStatuses;
      this.ss.createService(this.siteId, this.newService).then(
        (res: any) => {
          this.newService.id = res.key;
          this.ss.addLocalService(this.newService);
          this.dialogServiceRef.close(true);
        }
      ).catch(() => {
        this.fg.get('displayId').setErrors({ duplicate: true });
        this.fg.get('displayId').markAsTouched();
        this.fg.get('displayId').markAsDirty();
      }).finally(() => { this.ls.stopLoading(); });
    }

  }
}
